import { Blockquote, Inset, Text } from "@radix-ui/themes";


export default function Y2025M11D08() {

  return (
    <>
      <div className="container py-5">
        <div className='row'>

          <div className='col-lg-4'>
            <Inset clip="padding-box" side="top" pb="current">
              <img
                src="https://www.shadvala.org/img/interstices-2025-11-08.jpg"
                alt="Events"
                style={{
                  display: 'block',
                  objectFit: 'cover',
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'var(--gray-5)',
                }}
              />
              <Text as="p" mb="5" size="2">
                &copy; Interstices
              </Text>
            </Inset>
          </div>

          <div className='col-lg-8'>
            <div className="container">
              <div className='row py-3 border-top'>
                <div className='col'>
                  <Text as="p" mb="5" size="2" weight="bold">
                    08 November 2025, Palazzo Toppo Wassermann (Udine, Italy)
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="4" color>
                    Open Discussion: Book <i>Traces from the Labyrinth: Insights on Alain Daniélou</i> by Adrián Navigante
                  </Blockquote>
                  <Blockquote size="2" color>
                    Interstices Center in collaboration with FAD
                  </Blockquote>
                </div>
              </div> 
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="3">
                    The University of Udine and the Free University of Bolzano receive Adrián Navigante for a discussion on his book <i>Traces from the Labyrinth: Insights on Alain Daniélou</i>. Prof. Marcello Barison and Dr. Emma Lavinia Bon will speak with Adrián Navigante about his approach to the life and work of Alain Daniélou, which goes beyond the question of the reception of India in the West and intends to show Daniélou as the representative of a new form of humanism with a cross-cultural project that challenges Eurocentric parameters of thought and life. 
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}
